import { createUseTrackScreen } from '@bluecodecom/tracking';

import { ScreenName } from '../screens';
import trackingService from '../tracking';
import { TrackingEvents } from '../types';

/**
 * Reports a displayed screen twice — the catalogued universal `screen_displayed`
 * and this app's legacy `<Screen>: Opened` — for as long as the migration needs
 * both (catalog rule `dual-fire`).
 */
const useTrackScreen = createUseTrackScreen<ScreenName, TrackingEvents>(
  trackingService,
);

export default useTrackScreen;
